const TextP = ({text}) => {
  return(
      <p className="regular gray mb-16">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {text}
      </p>
  )
}
export default TextP